"use strict";

var focusevents = require("../global/focusevents");

/**
 * @function
 * @description function to set a cookie
 */
const setCookie = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

/**
 * @function
 * @description function to get the value of a cookie
 */
const getCookie = cname => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }

    return "";
};

/**
 * @function
 * @description function to set the previousRequestLocaleID local storage variable
 */
const setLocalVariable = () => {
    const $localeSuggestionAnchor = $(".locale-suggestion-anchor");

    if ($localeSuggestionAnchor.length > 0 && $localeSuggestionAnchor.data("request-id")) {
        localStorage.setItem("previousRequestLocaleID", $localeSuggestionAnchor.data("request-id"));
    }
};

/**
 * @function
 * @description function to initiate the locale suggestion popup
 */
const initLocaleSuggestion = () => {
    let localePopupShown = getCookie("localePopupShown");
    let previousRequestLocaleIDValue = window.localStorage.getItem("previousRequestLocaleID");
    const $localeSuggestionPopup = $("#localesuggetion");
    const $document = $(document);
    const $body = $("body");

    if (localePopupShown === "") {
        setCookie("localePopupShown", false, 1);
    }

    if ($localeSuggestionPopup.length > 0) {
        const $localeSuggestionAnchor = $(".locale-suggestion-anchor");

        if ($localeSuggestionAnchor.length > 0) {
            const localeID = $localeSuggestionAnchor.data("locale-id");
            const requestLocaleID = $localeSuggestionAnchor.data("request-id");
            const popupAllowedState = localePopupShown === "" || localePopupShown === "false";
            const popupReinitState = localePopupShown === "true" && (!previousRequestLocaleIDValue || (previousRequestLocaleIDValue && previousRequestLocaleIDValue !== requestLocaleID));

            if (localeID !== requestLocaleID && (popupAllowedState || popupReinitState)) {
                $localeSuggestionPopup.modal("show");
                $body.addClass("locale-suggestion-open");

                if ($localeSuggestionAnchor.hasClass("locale-suggestion-global")) {
                    $localeSuggestionAnchor.on("click", () => {
                        $document.trigger("setCookieVariable");
                        localStorage.setItem("previousRequestLocaleID", localeID);
                    });
                } else {
                    if (localeID) {
                        const $localesLinks = $localeSuggestionPopup.find(".c-country-selector__dropdown-item");

                        $localeSuggestionAnchor.removeAttr("href");

                        $localeSuggestionAnchor.on("click", () => {
                            $localesLinks.each((index, el) => {
                                const $this = $(el);
                                const dataLocale = $this.data("locale");

                                if (dataLocale && localeID === dataLocale) {
                                    $document.trigger("setCookieVariable");
                                    localStorage.setItem("previousRequestLocaleID", localeID);
                                    $this.trigger("click");
                                }
                            });
                        });
                    }
                }
            }
        }
    }

    $document.on("setCookieVariable", () => {
        setCookie("localePopupShown", true, 1);
    });

    $document.on("click", "#localesuggetion .close", () => {
        $document.trigger("setCookieVariable");
        setLocalVariable();
    });

    $document.on("click", ".locale-suggestion-close", () => {
        $localeSuggestionPopup.modal("hide");
        $document.trigger("setCookieVariable");
        setLocalVariable();
    });

    $localeSuggestionPopup.on("hide.bs.modal", () => {
        setTimeout(() => {
            $body.removeClass("locale-suggestion-open");
            focusevents.destroyFocusTrap($localeSuggestionPopup);
        }, 500);
    });

    $localeSuggestionPopup.on("shown.bs.modal", () => {
        setTimeout(() =>{
            focusevents.initFocusTrap($localeSuggestionPopup);
        }, 50);
    });

    $document.on("click", ".locale-suggestion-dropdown-link", e => {
        const $localesDropdown = $(".locale-suggestion-dropdown");

        if ($(e.target).is("div")) {
            const $this = $(e.target);

            if ($localesDropdown.length) {
                if ($localesDropdown.hasClass("d-none")) {
                    $localesDropdown.removeClass("d-none");
                    $this.addClass("locale-suggestion-dropdown-open");
                } else {
                    $localesDropdown.addClass("d-none");
                    $this.removeClass("locale-suggestion-dropdown-open");
                }
            }
        } else {
            if ($localesDropdown.length && !$localesDropdown.hasClass("d-none")) {
                $localesDropdown.addClass("d-none");
            }
        }
    });

    $document.on("keydown", ".locale-suggestion-dropdown-link", e => {
        const $localesDropdown = $(".locale-suggestion-dropdown");
        const $this = $(e.target);

        if ($this.is("div")) {

            if ($localesDropdown.length) {
                if (e.keyCode === 40) {
                    $localesDropdown.removeClass("d-none");
                    $this.addClass("locale-suggestion-dropdown-open");
                } else if (e.keyCode === 38) {
                    $localesDropdown.addClass("d-none");
                    $this.removeClass("locale-suggestion-dropdown-open");
                }
            }
        }

        if (e.keyCode === 13 && $this.hasClass("c-country-selector__dropdown-item")) {
            $this.trigger("click");
        }
    });
};

module.exports = initLocaleSuggestion;
